import { useSecondaryConnections } from './useSecondaryConnectionsHandler.js'
import { useSecondaryPulse } from './useSecondaryPulseHandler.js'
import { useSecondarySchedules } from './useSecondarySchedulesHandler.js'
import { useSecondarySkills } from './useSecondarySkillsHandler.js'
import { useSecondaryTriggers } from './useSecondaryTriggersHandler.js'

export function useAppShellBrowseNavHandlers(nav) {
  return {
    handleSecondaryPulse: useSecondaryPulse(nav),
    handleSecondarySchedules: useSecondarySchedules(nav),
    handleSecondaryTriggers: useSecondaryTriggers(nav),
    handleSecondarySkills: useSecondarySkills(nav),
    handleSecondaryConnections: useSecondaryConnections(nav),
  }
}
